"use client";

import React from "react";
const partners = [{
  id: 1,
  name: "Global Health Initiative",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/partner_global_health.png"
}, {
  id: 2,
  name: "Eco-Future Alliance",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/partner_eco_future.png"
}, {
  id: 3,
  name: "Unity Bank Corp",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/partner_unity_bank.png"
}, {
  id: 4,
  name: "Tech for Good",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/partner_tech_good.png"
}, {
  id: 5,
  name: "Community First",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/partner_community_first.png"
}, {
  id: 6,
  name: "Sustainable Growth Co",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/partner_sustainable_growth.png"
}, {
  id: 7,
  name: "Education Forward",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/partner_education_forward.png"
}, {
  id: 8,
  name: "Clean Water Network",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/partner_clean_water.png"
}];
const marqueeItems = [...partners, ...partners];
export default function CorporatePartnerships() {
  return <section data-section-id="222283" id="corporate-partnerships" className="py-20 dark bg-background text-foreground overflow-hidden relative border-y border-border/50">
      <style>{`
        @keyframes scroll-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll-marquee {
          animation: scroll-marquee 40s linear infinite;
        }
        
        .animate-scroll-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="w-full mx-auto max-w-[100vw]">
        <div className="mb-12 text-center px-4">
          <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tight mb-4 text-foreground">
            Our Collective Impact
          </h2>
          <p className="text-lg font-default text-muted-foreground max-w-2xl mx-auto">
            We are proud to collaborate with visionary organizations dedicated to creating lasting change. Join our network of corporate partners today.
          </p>
        </div>
        
        <div className="flex w-max animate-scroll-marquee items-center">
          {marqueeItems.map((partner, i) => <div key={`${partner.id}-${i}`} data-index={i} className="mx-10 md:mx-16 flex-shrink-0 flex items-center justify-center">
              <img src={partner.logo} alt={partner.name} className="h-10 md:h-12 w-auto object-contain grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-700 cursor-pointer" loading="lazy" />
            </div>)}
        </div>
      </div>
    </section>;
}